<div *ngIf="loading">
  <deltacapita-content-loader></deltacapita-content-loader>
</div>
<div *ngIf="!loading">
  <form [formGroup]="createIssuerContactForm" (ngSubmit)="createNewIssuerSalesContact()">
    <div class="form-group icon">
      <app-dc-select
        label="Issuer"
        [labelId]="'issuer'"
        [placeholder]="'Select issuer'"
        [items]="issuersDropdownData"
        [checkbox]="false"
        formControlName="issuerid"
        [disabled]="false"
        [multiple]="false"
        [searchable]="true"
        [closeOnSelect]="true"
        [readonly]="isIssuerSet"
      ></app-dc-select>
    </div>
    <div class="form-group icon">
      <app-dc-input formControlName="name" type="text" label="Name" [id]="'name'" placeholder="Name"></app-dc-input>
    </div>
    <div class="form-group icon">
      <app-dc-input formControlName="email" type="email" label="Email" placeholder="Email"></app-dc-input>
    </div>
    <div class="form-group icon">
      <app-dc-select
        label="Role"
        [placeholder]="'Select role'"
        [items]="rolesDropdownData"
        [checkbox]="false"
        formControlName="role"
        [disabled]="false"
        [multiple]="false"
        [searchable]="false"
        [closeOnSelect]="true"
        [readonly]="false"
      ></app-dc-select>
    </div>

    <div class="form-group icon">
      <label style="font-size: small">Sales Desk(s): </label>
      <div style="display: flex; flex-flow: row wrap">
        <div *ngFor="let salesdesk of allDesks" style="margin: 0 15px">
          <label style="font-size: small">
            <input
              type="checkbox"
              [value]="salesdesk"
              (change)="onDeskCheckboxChange($event)"
              [disabled]="isDeskDisabled"
              [checked]="currentTaggedDesks.includes(salesdesk)"
            />

            {{ salesdesk }}
          </label>
        </div>
      </div>
    </div>

    <div class="form-group icon">
      <label style="font-size: small">Sales Region(s): </label>
      <div style="display: flex; flex-flow: row-wrap">
        <div *ngFor="let salesregion of allRegions" style="margin: 0 15px">
          <label style="font-size: small">
            <input
              type="checkbox"
              [value]="salesregion"
              (change)="onRegionCheckboxChange($event)"
              [disabled]="isRegionDisabled"
              [checked]="currentTaggedRegions.includes(salesregion)"
            />

            {{ salesregion }}
          </label>
        </div>
      </div>
    </div>

    <br />
    <div class="m-3 d-flex align-items-center justify-content-center">
      <button class="btn btn-primary" type="submit" [disabled]="!validateForm()">Create Issuer Contact</button>
    </div>
  </form>
</div>
